import { useMutation, useQuery } from "@apollo/client";
import * as React from "react";
import { getUserId } from "../../helpers/functions";
import Button from "../Button/button.component";
import LoadingSpinner from "../LoadingSpinner/loading-spinner.component";
import AddWebhook from "./add-webhook.component";
import EditWebhook from "./edit-webhook.component";
import { GET_WEBHOOKS, SET_WEBHOOK_DISABLED, SET_WEBHOOK_ENABLED, DELETE_WEBHOOK } from "./query";
import { Container } from "./styles";
import Toggle from "react-toggle";
import { Badge } from "../MessagePreview/styles";

const WebhooksTable = () => {

	const { data, loading, error } = useQuery(GET_WEBHOOKS, {
		variables: {
			userId: getUserId(),
		},
		fetchPolicy: "network-only",
	});

	const [isOpen, setIsOpen] = React.useState(false);
	const [isEditOpen, setIsEditOpen] = React.useState(false);
	const [selectedWebhook, setSelectedWebhook] = React.useState(null);

	const [setWebhookIdEnabled, { loading: setWebhookLoading }] = useMutation(
		SET_WEBHOOK_ENABLED,
		{
			refetchQueries: [
				{
					query: GET_WEBHOOKS,
					variables: {
						userId: getUserId(),
					},
				},
			],
		}
	);

	const [setWebhookDisabled, { loading: webhookloading }] = useMutation(
		SET_WEBHOOK_DISABLED,
		{
			refetchQueries: [
				{
					query: GET_WEBHOOKS,
					variables: {
						userId: getUserId(),
					},
				},
			],
		}
	);

	const [deleteWebhook, { loading: deleteLoading }] = useMutation(DELETE_WEBHOOK, {
		refetchQueries: [
			{ query: GET_WEBHOOKS, variables: { userId: getUserId() } },
		],
	});

	const handleClose = () => {
		setIsOpen(false);
	};

	const handleOpen = () => {
		setIsOpen(true);
	};

	const handleEditOpen = (webhook) => {
		setSelectedWebhook(webhook);
		setIsEditOpen(true);
	};

	const handleEditClose = () => {
		setIsEditOpen(false);
		setSelectedWebhook(null);
	};

	const handleSetWebhook = async (id, isEnabled) => {
		if(isEnabled){
		await setWebhookIdEnabled({
			variables: {
				id
			},
		});
	} else {
		await setWebhookDisabled({
			variables: {
				id
			},
		});
	}
	};

	const handleDelete = async (id) => {
		const confirmed = window.confirm("Are you sure you want to delete this webhook?");
		if (!confirmed) return;
		await deleteWebhook({ variables: { id } });
	};

	if (loading) return <LoadingSpinner />;

	if (error) {
		return <p>oops... something went wrong</p>;
	}
	
	return (
		<Container>
			<table>
				<tr>
					<th>Target Url</th>
					<th>Type</th>
					<th>Failure Count</th>
					<th>Is Enabled</th>
					<th>Actions</th>
				</tr>
				{data.msgbox_ZapierWebhook.map((webhook) => (
					<tr key={webhook.ZapierWebHookId}> 
						<td>
							<p>{webhook.Target_Url}</p>
						</td>
						<td>
							<Badge>{webhook.Type}</Badge>
						</td>
						<td>
							<p>{webhook.FailureCount}</p>
						</td>
						<td>
							<Toggle
								id={webhook.ZapierWebHookId}
								onChange={async () => {
									await handleSetWebhook(
										webhook.ZapierWebHookId,
										!webhook.IsEnabled
									);
								}}
								disabled={setWebhookLoading || webhookloading}
								name="isEnabled"
								checked={webhook.IsEnabled === true}
							/>
						</td>
						<td>
							<button
								aria-label="Edit webhook"
								title="Edit"
								onClick={() => handleEditOpen(webhook)}
								style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 6 }}
							>
								<i className="fas fa-pen" />
							</button>
							<button
								aria-label="Delete webhook"
								title="Delete"
								onClick={() => handleDelete(webhook.ZapierWebHookId)}
								style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 6, color: '#c62828', marginLeft: 6 }}
								disabled={deleteLoading}
							>
								<i className="fas fa-trash" />
							</button>
						</td>
					</tr>
				))}
			</table>

			<Button
				primary
				buttonName="Add another webhook"
				onClick={handleOpen}
			/>
			<AddWebhook isOpen={isOpen} close={handleClose} />
			{selectedWebhook && (
				<EditWebhook 
					isOpen={isEditOpen} 
					close={handleEditClose} 
					webhook={selectedWebhook}
				/>
			)}
		</Container>
	);
};

export default WebhooksTable;
